module.exports = __webpack_public_path__ + "assets/0931327b06aeb2c1fa41e62417990c32.svg";